import { render, staticRenderFns } from "./StepInformacoesGerais.vue?vue&type=template&id=30c85ad4&scoped=true"
import script from "./StepInformacoesGerais.vue?vue&type=script&lang=js"
export * from "./StepInformacoesGerais.vue?vue&type=script&lang=js"
import style0 from "./StepInformacoesGerais.vue?vue&type=style&index=0&id=30c85ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c85ad4",
  null
  
)

export default component.exports